import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  modal: {
    display: 'flex',
    padding: '10% 5%',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  modalIcon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  modalText: {
    width: '100%',
  },
  title: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 24,
    lineHeight: '34px',
    fontWeight: font.weight.bold,
    color: colors.white,
  },
  spacer: {
    padding: '15px 0 0 15px',
  },
  orderList: {
    paddingLeft: 20,
  },
  text: {
    color: colors.white,
    lineHeight: '24px',
    fontWeight: font.weight.light
  },
});

export default styles;
